import { c as _c } from "react-compiler-runtime";
import * as React from "react";
import { Group, Radio as AriaRadio, RadioGroup as AriaRadioGroup } from "react-aria-components";
import { icon as iconStyle } from "../icon.css.js";
import { button, buttonGroup, buttonGroupItems, radioButton } from "./ButtonGroup.css.js";
import { Label } from "./Label.js";
import { Tooltip } from "./Tooltip.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function BaseButtonGroup(props, ref) {
  const $ = _c(13);
  let children;
  let label;
  let radioProps;
  if ($[0] !== props) {
    ({
      children,
      label,
      ...radioProps
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = label;
    $[3] = radioProps;
  } else {
    children = $[1];
    label = $[2];
    radioProps = $[3];
  }
  let t0;
  if ($[4] !== label) {
    t0 = label != null && /*#__PURE__*/_jsx(Label, {
      children: label
    });
    $[4] = label;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  let t1;
  if ($[6] !== children) {
    t1 = /*#__PURE__*/_jsx(Group, {
      className: buttonGroupItems,
      children: children
    });
    $[6] = children;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== radioProps || $[9] !== ref || $[10] !== t0 || $[11] !== t1) {
    t2 = /*#__PURE__*/_jsxs(AriaRadioGroup, {
      className: buttonGroup,
      ref: ref,
      orientation: "horizontal",
      ...radioProps,
      children: [t0, t1]
    });
    $[8] = radioProps;
    $[9] = ref;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}
export const ButtonGroup = /*#__PURE__*/React.forwardRef(BaseButtonGroup);
function OptionalTooltip(props) {
  const $ = _c(8);
  let children;
  let tooltip;
  let tooltipProps;
  if ($[0] !== props) {
    ({
      tooltip,
      children,
      ...tooltipProps
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = tooltip;
    $[3] = tooltipProps;
  } else {
    children = $[1];
    tooltip = $[2];
    tooltipProps = $[3];
  }
  if (tooltip != null) {
    let t0;
    if ($[4] !== children || $[5] !== tooltip || $[6] !== tooltipProps) {
      t0 = /*#__PURE__*/_jsx(Tooltip, {
        ...tooltipProps,
        text: tooltip,
        children: children
      });
      $[4] = children;
      $[5] = tooltip;
      $[6] = tooltipProps;
      $[7] = t0;
    } else {
      t0 = $[7];
    }
    return t0;
  }
  return children;
}
function BaseButtonGroupItem(props, ref) {
  const $ = _c(16);
  let Icon;
  let children;
  let radioProps;
  let tooltip;
  if ($[0] !== props) {
    ({
      children,
      tooltip,
      icon: Icon,
      ...radioProps
    } = props);
    $[0] = props;
    $[1] = Icon;
    $[2] = children;
    $[3] = radioProps;
    $[4] = tooltip;
  } else {
    Icon = $[1];
    children = $[2];
    radioProps = $[3];
    tooltip = $[4];
  }
  const [hovering, setHovering] = React.useState(false);
  const triggerRef = React.useRef(null);
  let t0;
  if ($[5] !== Icon) {
    t0 = Icon && /*#__PURE__*/_jsx(Icon, {
      className: iconStyle({
        size: "s"
      })
    });
    $[5] = Icon;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  let t1;
  if ($[7] !== children || $[8] !== radioProps || $[9] !== ref || $[10] !== t0) {
    t1 = /*#__PURE__*/_jsx("div", {
      ref: triggerRef,
      className: radioButton,
      children: /*#__PURE__*/_jsxs(AriaRadio, {
        className: _temp,
        ref: ref,
        ...radioProps,
        onHoverChange: setHovering,
        onFocusChange: setHovering,
        children: [t0, children]
      })
    });
    $[7] = children;
    $[8] = radioProps;
    $[9] = ref;
    $[10] = t0;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  let t2;
  if ($[12] !== hovering || $[13] !== t1 || $[14] !== tooltip) {
    t2 = /*#__PURE__*/_jsx(OptionalTooltip, {
      tooltip: tooltip,
      isOpen: hovering,
      triggerRef: triggerRef,
      children: t1
    });
    $[12] = hovering;
    $[13] = t1;
    $[14] = tooltip;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  return t2;
}
function _temp(t0) {
  const {
    isDisabled
  } = t0;
  return button({
    isDisabled
  });
}
export const ButtonGroupItem = /*#__PURE__*/React.forwardRef(BaseButtonGroupItem);
//# sourceMappingURL=ButtonGroup.js.map